module.exports = __webpack_public_path__ + "platform-web/static/media/announce.02984e16.svg";